module.exports = __webpack_public_path__ + "static/img/visa.b5b210b5.png";